import ProductTilesList from './ProductTilesList';

export default ProductTilesList;
